
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta } from "/vercel/path0/pages/suche.vue?macro=true";
import { default as _91_46_46_46uri_93BVPCLsM3jESHzL4Q2xtwhuQBw9sdXq80L9Jw_nFubMcMeta } from "/vercel/path0/pages/[...uri].vue?macro=true";
import { default as styleguideUJgsG_J4d_j7Mn3lh3sFFGfvxhr7YPDBMRUzlLBIL5YMeta } from "/vercel/path0/pages/styleguide.vue?macro=true";
export default [
  {
    name: "search___de",
    path: "/suche",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "search___br_de",
    path: "/br_de/suche",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "search___br_fr",
    path: "/br_fr/suche",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "search___br_en",
    path: "/br_en/suche",
    meta: sucheYRIc9pZLNBAeGqx2pPhB4Ec24tUxNYQqe5MUALdtkM4Meta || {},
    component: () => import("/vercel/path0/pages/suche.vue")
  },
  {
    name: "uri___de",
    path: "/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___fr",
    path: "/fr/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___en",
    path: "/en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___br_de",
    path: "/br_de/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___br_fr",
    path: "/br_fr/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "uri___br_en",
    path: "/br_en/:uri(.*)*",
    component: () => import("/vercel/path0/pages/[...uri].vue")
  },
  {
    name: "styleguide___de",
    path: "/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___fr",
    path: "/fr/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___en",
    path: "/en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___br_de",
    path: "/br_de/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___br_fr",
    path: "/br_fr/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  },
  {
    name: "styleguide___br_en",
    path: "/br_en/styleguide",
    component: () => import("/vercel/path0/pages/styleguide.vue")
  }
]